<div *ngIf="showLoadingState$ | async" class="d-flex justify-content-center align-items-center flex-grow-1 h-100 main-loading-spinner">
  <mat-spinner />
</div>
